import React, { FC, ReactNode } from 'react';
import './program-billing.css';

export interface ProgramResultCardProps {
  eyebrow: string;
  title: string;
  subtitle?: ReactNode;
  /** Shows a spinner in the badge instead of the check. */
  pending?: boolean;
  children?: ReactNode;
  actions?: ReactNode;
}

const Check: FC = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M5 12.5l4.5 4.5L19 7" />
  </svg>
);

/** Centered confirmation card for billing and create-team results. */
const ProgramResultCard: FC<ProgramResultCardProps> = ({
  eyebrow,
  title,
  subtitle,
  pending = false,
  children,
  actions,
}) => (
  <div className="pb-result-page">
    <div className="pb-result">
      <div className="pb-result-hero">
        <span className={`pb-result-badge${pending ? ' pb-result-badge-pending' : ''}`}>
          {pending ? <span className="pb-result-spinner" aria-label="Loading" /> : <Check />}
        </span>
        <div className="pb-result-eyebrow">{eyebrow}</div>
        <h1 className="pb-result-title">{title}</h1>
        {subtitle ? <p className="pb-result-sub">{subtitle}</p> : null}
      </div>
      {children ? <div className="pb-result-body">{children}</div> : null}
      {actions ? <div className="pb-result-actions">{actions}</div> : null}
    </div>
  </div>
);

export default ProgramResultCard;
